import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Starter } from 'models/StarterModel';


const CompanyNew: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.COMPANY, Code.Form.Name.COMPANY];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [cityOptions, setCityOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Starter>({});
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.CITY, Code.Option.Common.SELECT, setCityOptions, setError);
    
    API.Data.GetByKeyId<Starter>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setFormData((prevData) => ({
        ...prevData,
        ...formData,
      }));
      //setLoading(false);
    }})

    setLoading(false);

    // const onNewEntry = async () => {
    //   setFormData((prev) => ({
    //     ...prev, 
    //     company_name: "Test ", 
    //     company_legal_name: "Test ", 
    //     company_phone: "0000000000", 
    //     company_email: "test@test.com", 
    //     company_website: "www.test.com", 
    //     company_address: "Test Calgary", 
    //     city_id: 10, 
    //     company_postal: "T3J 0S3", 
    //   }));
    //   setLoading(false);
    // };
    // onNewEntry();
    
      
  }, []);

  const onSubmit = (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;

    const finalData = Utility.Sanitize.FormData({
      ...formData,
      user_id: Utility.Storage.UserId(),
      company_phone: Utility.Convert.Number(formData.company_phone),
    });

    API.Data.Starter(finalData, setMessage)

  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={"New Company"} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Create Company"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
 
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Box>
                <Field.Text id={Name.Company.Name} value={formData.company_name} title="New Company Name" onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
                <Field.Text id={Name.Company.LegalName} value={formData.company_legal_name} title="New Company Legal Name" onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true}  />
              </Control.Box>
              <Control.Row>
                <Field.Text id={Name.Company.Phone} value={Utility.Format.Phone(formData.company_phone)} title={Title.Phone} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} />
                <Field.Text id={Name.Company.Email} value={formData.company_email} title={Title.Email} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} />
              </Control.Row>
              <Control.Box>
                <Field.Text id={Name.Company.Website} value={formData.company_website} title={Title.Website} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
                <Field.Area id={Name.Company.Address} value={formData.company_address} title={Title.Address} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
              </Control.Box>
              <Control.Row>
                <Field.Select id={Name.City.Id} value={formData.city_id} title={Title.City} options={cityOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[0,50,1]} require={true} />
                <Field.Text id={Name.Company.Postal} value={formData.company_postal} title={Title.Postal} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} />
              </Control.Row>
            </Control.Tab.Content>

          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default CompanyNew;